import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EditListingIntroductoryForm from 'forms/EditListingIntroductoryForm/EditListingIntroductoryForm';

import css from '../EditListingExpectationsPanel/EditListingExpectationsPanel.css';

const EditListingIntroductoryPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const form = (
    <EditListingIntroductoryForm
      className={css.form}
      initialValues={{ introductoryVideo: listing.attributes.publicData.introductoryVideo }}
      onSubmit={onSubmit}
      onChange={onChange}
      saveActionMsg={submitButtonText}
      disabled={disabled}
      ready={ready}
      updated={panelUpdated}
      updateInProgress={updateInProgress}
      fetchErrors={errors}
    />
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>Introductory Video</h1>
      {form}
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingIntroductoryPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingIntroductoryPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingIntroductoryPanel;
